module.exports = __webpack_public_path__ + "img/quadrado_32.e4e9b2fb.jpg";